import React, { useState } from 'react'
import { SocialButton } from './SocialButton'
import copy from 'copy-to-clipboard'
import * as styles from './ShareLink.module.scss'

export const ShareLink = ({ ...props }) => {
  const [wasCopied, setWasCopied] = useState(false)

  const onCopy = () => {
    const copySuccessful = copy(window.location.origin + window.location.pathname)
    setWasCopied(copySuccessful)
  }

  return (
    <SocialButton
      as={'button'}
      className={`cursor-pointer ${styles.shareLink} ${wasCopied ? styles.copied : ''} `}
      onClick={onCopy}
      { ...props }
    >
      <i className='fa fa-link'/>
    </SocialButton>
  )
}
